// eslint-disable-next-line unicorn/prefer-module
const getWindowUrl = require('./getWindowUrl');

const PREFIX_REGEX = /^https?:\/\/[^/]+(\/(fr)?)/;

const getRelativePrefix = (requestUrl) => {
  const url = requestUrl || getWindowUrl();
  const [, prefix] = url.match(PREFIX_REGEX) || [];
  return prefix;
};

// eslint-disable-next-line unicorn/prefer-module
module.exports = getRelativePrefix;
